import { __decorate } from "tslib";
import { Vue, Component, Mixins } from 'vue-property-decorator';
import { uiMapper } from '@/services/store/modules/ui/store';
import { dataMapper } from '@/services/store/modules/data/store';
import IconSvg from './IconSvg.vue';
import StepQuizSelect from './StepQuizSelect.vue';
import StepQuizCheckbox from './StepQuizCheckbox.vue';
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(['formCallIsShown', 'breakpoint'])
    }
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(['videoLink', 'quiz']),
        ...dataMapper.mapGetters(['quizAnswer'])
    },
    methods: {
        ...dataMapper.mapMutations(['updateQuizField', 'clearQuiz'])
    }
});
let StepsQuiz = class StepsQuiz extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.activeStepIndex = 0;
        this.itemsPerCol = 3;
        this.selectActiveIndexes = null;
    }
    get isGtLg() { return this.breakpoint === 'lg' || this.breakpoint === 'xl'; }
    get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm'; }
    get steps() { return this.quiz.data; }
    created() {
        this.clearQuiz();
    }
    updateValue(payload) {
        const { index, value, valueIndex, subValueIndex } = payload;
        this.updateQuizField({ stepIndex: index, value, valueIndex, subValueIndex });
    }
    toggleSelect(index, selectIndex) {
        this.selectActiveIndexes === index + selectIndex.toString() ? this.selectActiveIndexes[selectIndex] = null : this.selectActiveIndexes[selectIndex] = index;
    }
    getStepValue(index) {
        return this.steps[index];
    }
};
StepsQuiz = __decorate([
    Component({
        components: {
            IconSvg,
            StepQuizSelect,
            StepQuizCheckbox
        },
    })
], StepsQuiz);
export default StepsQuiz;
